import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ManagementReservationSearchDefault } from "@/components/features/management/reservation";

import { useConfirmParams } from "./hooks";

export const ManagementReservationTopPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID, reservationSearchType, startDate, endDate, reservationID } = result;

	return (
		<PageMeta title="予約の管理" url={generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.TOP, { hotelID })}>
			<ManagementReservationSearchDefault
				hotelID={hotelID}
				reservationSearchType={reservationSearchType}
				startDate={startDate}
				endDate={endDate}
				reservationID={reservationID}
			/>
		</PageMeta>
	);
};
